/**
 * Vuex mutations for the "siwfauth" module.
 *
 * Synchronous state writer for the stored SIWF data. Async work (fetching it)
 * lives in operations.js.
 */
export default {
  setSiwfData(state, data) {
    state.siwfData = data;
  },
};
